import React from 'react'
import PropTypes from 'prop-types'
import {
  Alert,
  Badge,
  Button,
  Col,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
} from 'reactstrap'
import { Formik } from 'formik'
import ErrorBoundary from 'components/ErrorBoundary'
import FieldsetItemLarge from 'components/FieldsetItemLarge'
import FormikInputField from 'components/FormikInputField'
import SchoolLookUp from 'components/SchoolLookUp'
import { editSiteSchema } from '../../lib/schemas'

const EditSiteModal = ({
  assignedTo,
  companyName,
  currentSchool,
  customerIdValidateAsync,
  handleSubmit,
  isOpen,
  nsCustomerId,
  schoolSelected,
  site,
  toggle,
}) => (
  <Modal
    backdrop="static"
    centered
    fade
    isOpen={isOpen}
    size="lg"
    toggle={toggle}
  >
    {site && currentSchool && (
      <React.Fragment>
        <ModalHeader toggle={toggle}>
          Site Edit&nbsp;
          <Badge>SS: {site.id}</Badge>
          {nsCustomerId && <Badge>NS: {nsCustomerId}</Badge>}
        </ModalHeader>
        <ErrorBoundary>
          <Formik
            initialValues={{
              id: site.id,
              organizationId: site.organizationId,
              ...currentSchool,
            }}
            isInitialValid={false}
            onSubmit={handleSubmit}
            validationSchema={editSiteSchema}
          >
            {props => (
              <form onSubmit={props.handleSubmit}>
                <ModalBody>
                  <fieldset>
                    <legend>Details</legend>
                    <Row>
                      <Col sm={8}>
                        <FieldsetItemLarge
                          data={companyName || 'Not Assigned to NS Customer'}
                          title="Customer Name"
                        />
                        <FieldsetItemLarge
                          data={assignedTo}
                          title="Assigned To"
                        />
                      </Col>
                    </Row>
                  </fieldset>
                  <ErrorBoundary>
                    <hr />
                    <h5>OrganizationId</h5>
                    <FormikInputField
                      label="Organization ID"
                      name="organizationId"
                      type="number"
                      {...props}
                    />
                    <hr />
                    <h5>Assignee</h5>
                    <Alert color="info">
                      Reassign the Netsuite Customer that is linked to this site
                      by entering the NetSuite Customer ID OR by using the
                      dropdown menu. If you use the dropdown menu, leave the
                      Customer ID blank
                    </Alert>
                    <FormikInputField
                      label="NetSuite Customer ID"
                      name="nsCustomerId"
                      type="text"
                      validate={values =>
                        customerIdValidateAsync(values, props)
                      }
                      {...props}
                    />
                    <hr />
                    <SchoolLookUp
                      disabled={!!props.values.nsCustomerId}
                      key={site.id}
                      onSelection={data => schoolSelected(props, data)}
                      siteData={currentSchool}
                    />
                  </ErrorBoundary>
                </ModalBody>
                <ModalFooter>
                  <Button
                    className="btn-fixed-width"
                    color="link"
                    disabled={props.isSubmitting}
                    onClick={toggle}
                    style={{
                      fontSize: '18px',
                      fontFamily: 'Molde-Medium',
                      color: '#5F5F5F',
                      margin: '12px 0px auto',
                    }}
                  >
                    Cancel
                  </Button>
                  <Button
                    className="btn-fixed-width"
                    color={props.isSubmitting ? 'disabled' : 'primary'}
                    disabled={
                      props.isSubmitting ||
                      props.isValidating ||
                      !props.isValid ||
                      !props.touched
                    }
                    style={{
                      margin: '12px 4px 24px 48px',
                      width: '130px',
                      height: '42px',
                      fontSize: '18px',
                      fontFamily: 'Molde-Medium',
                    }}
                    type="submit"
                  >
                    Submit
                  </Button>
                </ModalFooter>
              </form>
            )}
          </Formik>
        </ErrorBoundary>
      </React.Fragment>
    )}
  </Modal>
)

EditSiteModal.propTypes = {
  assignedTo: PropTypes.string,
  companyName: PropTypes.string,
  currentSchool: PropTypes.object,
  customerIdValidateAsync: PropTypes.func,
  handleSubmit: PropTypes.func,
  isOpen: PropTypes.bool,
  nsCustomerId: PropTypes.string,
  site: PropTypes.object,
  toggle: PropTypes.func,
}

export default EditSiteModal



// WEBPACK FOOTER //
// ./src/components/EditSiteModal/component.jsx